import React from 'react'

import { ReactComponent as CloseIcon } from '../../../../assets/icons/layout/fechar.svg'

import * as S from './styles'

export default function ModalDefault(props) {
  return (
    <S.Modal className={props.active ? 'active' : ''} zIndex={props.zIndex} data-cy={props.dataCy}>
      <S.Content width={props.width} >
        <S.Internal>
          <S.Header>
            {props.title && <S.Title>{props.title}</S.Title>}
            {props.subtitle && <S.Subtitle>{props.subtitle}</S.Subtitle>}
            {!props.noButtonClose &&
              <S.BtnClose onClick={props.onClick}><CloseIcon /></S.BtnClose>}
            {props.title && <S.Separator />}
          </S.Header>
          <S.Body>{props.children}</S.Body>
        </S.Internal>
      </S.Content>
    </S.Modal>
  )
}
